import { frontendURL } from 'dashboard/helper/URLHelper';
import WhatsAppInstances from './WhatsAppInstances.vue';
import EloquentHub from './EloquentHub.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/wa-instances'),
    name: 'wa_instances',
    component: WhatsAppInstances,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/eloquent-hub'),
    name: 'eloquent_hub',
    component: EloquentHub,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];
